// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import CloseIcon from 'components/svg/close.svg'
import SearchIcon from 'components/svg/search.svg'

// Redux:
import {
	openSearch,
	closeSearch,
	setSearchInput,
	getSearchData,
} from 'actions/search'

class SearchBar extends React.Component {
	constructor() {
		super()

		this.typingTimer
		this.doneTypingInterval = 2000
	}

	componentWillMount() {
		// Close the search on back:
		window.onpopstate = () => {
			this.closeSearch()
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.searchIsOpen && ! prevProps.searchIsOpen ) {
			this.searchInput.focus()
		}
	}

	openSearch = () => {
		const { dispatch } = this.props

		dispatch( openSearch() )
	}

	closeSearch = () => {
		const { dispatch } = this.props

		dispatch( closeSearch() )
	}

	handleChange = ( e ) => {
		const { dispatch } = this.props

		dispatch( setSearchInput( e.target.value ) )
	}

	handleSubmit = ( e ) => {
		const { dispatch, searchTerm } = this.props

		dispatch( getSearchData( searchTerm ) )

		if ( window.innerWidth <= siteData.mobile_max_width ) {
			this.searchInput.blur()
		}

		e.preventDefault()
	}

	handleKeyDown = ( e ) => {
		const { dispatch, searchTerm } = this.props

		let isEscape = false,
			isSpace = false

		if ( 'key' in e ) {
			isEscape = ( e.key == 'Escape' || e.key == 'Esc' )
			isSpace = ( e.key == 'Space' || e.key == ' ' )
		} else {
			isEscape = ( e.keyCode == 27 )
			isSpace = ( e.keyCode == 32 )
		}

		if ( isEscape ) {
			this.closeSearch()
			return
		}

		if ( isSpace ) {
			dispatch( getSearchData( searchTerm ) )
			return
		}

		// Get data after there has been at least doneTypingInterval time after the last change.
		if ( this.typingTimer ) {
			clearTimeout( this.typingTimer )
		}

		this.typingTimer = setTimeout( () => {
			dispatch( getSearchData( searchTerm ) )
		}, this.doneTypingInterval )
	}

	render() {
		const { searchTerm } = this.props

		return (
			<div className="search-bar">
				<div className="search-scroll-position"></div>

				<form className="-form" action="" method="get" onSubmit={ this.handleSubmit }>
					<div className="-input">
						<input type="text"
							ref={ ( e ) => { this.searchInput = e } }
							value={ searchTerm }
							onChange={ this.handleChange }
							onKeyDown={ this.handleKeyDown }
							className="large"
							placeholder="Search here..."
						/>

						<CloseIcon onClick={ this.closeSearch } />
					</div>

					<div className="-button" onClick={ this.openSearch }>
						<SearchIcon />
					</div>
				</form>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchIsOpen: state.search.isOpen,
		searchTerm: state.search.searchTerm
	}
}

export default connect( mapStateToProps )( SearchBar )



// WEBPACK FOOTER //
// ./components/Search/SearchBar.jsx